import request from "@/utils/request";

export default function getMonthlyByDeviceGroupId(groupId) {
    return request({
        url: `/device/monthly/getMonthlyByDeviceGroupId/${groupId}`,
    })
}
